/* Leafiya Care — interactions */
(function () {
  'use strict';

  /* Header scroll state */
  var header = document.querySelector('.site-header');
  function onScroll() {
    if (!header) return;
    header.classList.toggle('scrolled', window.scrollY > 24);
  }
  window.addEventListener('scroll', onScroll, { passive: true });
  onScroll();

  /* Reveal on scroll */
  var faders = document.querySelectorAll('.fade');
  if ('IntersectionObserver' in window && faders.length) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('in'); io.unobserve(e.target); }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -8% 0px' });
    faders.forEach(function (el, i) {
      el.style.transitionDelay = (Math.min(i % 4, 3) * 0.08) + 's';
      io.observe(el);
    });
  } else {
    faders.forEach(function (el) { el.classList.add('in'); });
  }

  /* Accordion */
  document.addEventListener('click', function (e) {
    var head = e.target.closest('.acc-head');
    if (!head) return;
    var item = head.parentElement;
    var body = item.querySelector('.acc-body');
    var open = item.classList.toggle('open');
    body.style.maxHeight = open ? (body.querySelector('.acc-body-inner').offsetHeight + 40) + 'px' : null;
  });

  /* Quantity */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-qty]');
    if (!btn) return;
    var wrap = btn.closest('.qty');
    var input = wrap.querySelector('input');
    var v = parseInt(input.value, 10) || 1;
    v += btn.dataset.qty === 'up' ? 1 : -1;
    if (v < 1) v = 1;
    input.value = v;
  });

  /* PDP thumbnails */
  document.addEventListener('click', function (e) {
    var thumb = e.target.closest('.pdp-thumb');
    if (!thumb) return;
    var gallery = thumb.closest('.pdp-gallery');
    var main = gallery.querySelector('.pdp-main-img');
    var src = thumb.dataset.src;
    gallery.querySelectorAll('.pdp-thumb').forEach(function (t) { t.classList.remove('active'); });
    thumb.classList.add('active');
    if (main && src) main.src = src;
  });

  /* Mobile menu */
  var menu = document.querySelector('.mobile-menu');
  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-menu-open]')) { menu && menu.classList.add('open'); document.body.style.overflow = 'hidden'; }
    if (e.target.closest('[data-menu-close]') || e.target.matches('.mobile-menu a')) {
      menu && menu.classList.remove('open'); document.body.style.overflow = '';
    }
  });

  /* ---------- Cart (AJAX) ---------- */
  var cfg = window.leafiya || { moneyFormat: '${{amount}}', cartUrl: '/cart', strings: {} };
  var drawer = document.querySelector('.drawer');
  var scrim = document.querySelector('.drawer-scrim');
  var cartBody = document.getElementById('cart-body');

  function formatMoney(cents) {
    var value = (cents / 100);
    var fmt = cfg.moneyFormat || '${{amount}}';
    // amount with 2 decimals and thousands separators
    var withDecimals = value.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    var noDecimals = Math.round(value).toLocaleString('en-US');
    var out = fmt
      .replace(/\{\{\s*amount\s*\}\}/g, withDecimals)
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, noDecimals)
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, value.toFixed(2).replace('.', ',').replace(/\B(?=(\d{3})+(?!\d))/g, '.'))
      .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/g, noDecimals);
    return out;
  }

  function openCart() { drawer && drawer.classList.add('open'); scrim && scrim.classList.add('open'); document.body.style.overflow = 'hidden'; }
  function closeCart() { drawer && drawer.classList.remove('open'); scrim && scrim.classList.remove('open'); document.body.style.overflow = ''; }

  function setCount(n) {
    document.querySelectorAll('#cart-count, .cart-count').forEach(function (el) { el.textContent = n; });
  }

  function renderCart(cart) {
    setCount(cart.item_count);
    if (!cartBody) return;
    if (!cart.items || cart.items.length === 0) {
      cartBody.innerHTML =
        '<div class="cart-empty"><p style="margin-top:14px">' + (cfg.strings.empty || 'Your cart is empty.') +
        '</p><a href="/collections/all" class="btn btn--ghost" style="margin-top:8px">Shop the collection</a></div>';
      var foot = document.querySelector('.drawer-foot'); if (foot) foot.style.display = 'none';
      return;
    }
    var foot = document.querySelector('.drawer-foot'); if (foot) foot.style.display = '';
    var html = '';
    cart.items.forEach(function (item) {
      var img = item.image
        ? '<img src="' + item.image.replace(/(\.[a-z]+)(\?|$)/i, '_120x$2') + '" alt="">'
        : '';
      html +=
        '<div class="cart-line">' +
          '<div class="cart-line-media">' + img + '</div>' +
          '<div style="flex:1">' +
            '<h4 style="font-family:var(--serif);font-size:1.2rem">' + item.product_title + '</h4>' +
            (item.variant_title ? '<p class="muted" style="font-size:.82rem;margin:2px 0">' + item.variant_title + '</p>' : '') +
            '<div class="cart-line-qty" style="display:inline-flex;align-items:center;gap:10px;margin-top:8px">' +
              '<button class="cart-step" data-line="' + item.key + '" data-dir="down" aria-label="Decrease">−</button>' +
              '<span>' + item.quantity + '</span>' +
              '<button class="cart-step" data-line="' + item.key + '" data-dir="up" aria-label="Increase">+</button>' +
            '</div>' +
          '</div>' +
          '<div style="text-align:right">' +
            '<button class="cart-remove" data-line="' + item.key + '" aria-label="Remove">&times;</button>' +
            '<p style="font-family:var(--serif);font-size:1.15rem;margin-top:10px">' + formatMoney(item.final_line_price) + '</p>' +
          '</div>' +
        '</div>';
    });
    var subtotal = '<div class="cart-subtotal"><span>Subtotal</span><b>' + formatMoney(cart.total_price) + '</b></div>';
    cartBody.innerHTML = html + subtotal;
  }

  function refreshCart(open) {
    fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) { renderCart(cart); if (open) openCart(); })
      .catch(function () { if (open) window.location.href = cfg.cartUrl; });
  }

  function changeLine(key, qty) {
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    }).then(function (r) { return r.json(); }).then(renderCart);
  }

  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-cart-open]')) { e.preventDefault(); refreshCart(true); return; }
    if (e.target.closest('[data-cart-close]') || e.target === scrim) { closeCart(); return; }
    var rm = e.target.closest('.cart-remove'); if (rm) { changeLine(rm.dataset.line, 0); return; }
    var step = e.target.closest('.cart-step');
    if (step) {
      var line = step.closest('.cart-line');
      var cur = parseInt(line.querySelector('.cart-line-qty span').textContent, 10) || 1;
      changeLine(step.dataset.line, step.dataset.dir === 'up' ? cur + 1 : Math.max(0, cur - 1));
    }
  });
  window.leafiyaOpenCart = function () { refreshCart(true); };

  /* Add to cart via AJAX (progressive enhancement; falls back to normal submit) */
  var pform = document.querySelector('.product-form');
  if (pform && window.fetch) {
    var buyNowClicked = false;
    pform.addEventListener('click', function (e) {
      buyNowClicked = !!e.target.closest('[data-buy-now]');
    });
    pform.addEventListener('submit', function (e) {
      e.preventDefault();
      var goCheckout = buyNowClicked;
      buyNowClicked = false;
      var btn = pform.querySelector('[data-add-btn]');
      var label = pform.querySelector('[data-add-label]');
      var prev = label ? label.textContent : '';
      if (btn) btn.disabled = true;
      if (label && !goCheckout) label.textContent = 'Adding…';
      fetch('/cart/add.js', { method: 'POST', body: new FormData(pform), headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, data: d }; }); })
        .then(function (res) {
          if (btn) btn.disabled = false;
          if (!res.ok) { alert(res.data && res.data.description ? res.data.description : 'Could not add to cart.'); return; }
          if (goCheckout) { window.location.href = '/checkout'; return; }
          if (label) label.textContent = (cfg.strings.added || 'Added') + ' ✓';
          refreshCart(true);
          setTimeout(function () { if (label) label.textContent = prev; }, 1600);
        })
        .catch(function () { if (btn) btn.disabled = false; if (label) label.textContent = prev; pform.submit(); });
    });
  }

  /* Variant selection: update hidden id, price and availability */
  var pjsonEl = document.querySelector('[data-product-json]');
  if (pjsonEl && pform) {
    var variants = [];
    try { variants = JSON.parse(pjsonEl.textContent); } catch (err) {}
    var selects = pform.querySelectorAll('[data-product-option]');
    function updateVariant() {
      var chosen = Array.prototype.map.call(selects, function (s) { return s.value; });
      var match = variants.find(function (v) {
        return (v.options || []).every(function (opt, i) { return opt === chosen[i]; });
      });
      var idInput = pform.querySelector('[data-variant-id]');
      var priceEl = document.querySelector('[data-price]');
      var cmpEl = document.querySelector('[data-price-compare]');
      var saveEl = document.querySelector('[data-price-save]');
      var label = pform.querySelector('[data-add-label]');
      var btn = pform.querySelector('[data-add-btn]');
      if (!match) { if (btn) { btn.disabled = true; } if (label) label.textContent = 'Unavailable'; return; }
      if (idInput) idInput.value = match.id;
      if (priceEl) priceEl.textContent = formatMoney(match.price);
      if (cmpEl) {
        if (match.compare_at_price && match.compare_at_price > match.price) {
          cmpEl.textContent = formatMoney(match.compare_at_price); cmpEl.hidden = false;
          if (saveEl) { saveEl.textContent = 'Save ' + Math.round((match.compare_at_price - match.price) * 100 / match.compare_at_price) + '%'; saveEl.hidden = false; }
        } else { cmpEl.hidden = true; if (saveEl) saveEl.hidden = true; }
      }
      if (btn) btn.disabled = !match.available;
      if (label) label.textContent = match.available ? (pform.getAttribute('data-add') || 'Add to cart') : 'Sold out';
    }
    selects.forEach(function (s) { s.addEventListener('change', updateVariant); });
  }

  /* Keep header count in sync on load */
  if (document.querySelector('.cart-count')) refreshCart(false);

  /* Theme toggle */
  document.addEventListener('click', function (e) {
    if (!e.target.closest('[data-theme-toggle]')) return;
    var root = document.documentElement;
    var next = root.getAttribute('data-theme') === 'dark' ? 'light' : 'dark';
    root.setAttribute('data-theme', next);
    try { localStorage.setItem('leafiya-theme', next); } catch (err) {}
    var meta = document.querySelector('meta[name="theme-color"]');
    if (meta) meta.setAttribute('content', next === 'dark' ? '#15171A' : '#F7F3EC');
  });
})();
